import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";

import messages from "../../../../../../../assets/locale/messages";
import Button from "../../../../../../../components/Button";
import Input from "../../../../../../../components/Input";
import Modal from "../../../../../../../components/Modal";
import { requestEditOffPlatformDocs } from "../../../../../../../store/BusinessVerification/actions";
import {
  EditBgIcon,
  EditUnderlineIcon
} from "../../../../../../../utils/Icons";

const RequestUpdates = () => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      actions: { requestUpdates }
    },
    shared
  } = messages[lang];

  const requestDetails = useSelector(
    (state) => state.businessVerification.verificationRequestMainInfo
  );

  const [modalOpen, setModalOpen] = useState(false);

  const {
    values,
    setFieldValue,
    handleSubmit,
    setFieldTouched,
    dirty,
    isValid,
    touched,
    errors,
    resetForm
  } = useFormik({
    initialValues: {
      updates: ""
    },
    validationSchema: Yup.object({
      updates: Yup.string()
        .required("requestOffPlatformDocsUpdatesRequired")
        .max(200, "requestOffPlatformDocsUpdatesMaxLength")
    }),
    onSubmit: ({ updates }) => {
      dispatch(
        requestEditOffPlatformDocs({
          Id: requestDetails?.Id,
          Notes: updates
        })
      );
      setOpenModal(false);
    }
  });

  const renderUpdatesInput = () => (
    <form onSubmit={handleSubmit} noValidate className="mt-3 mt-md-0">
      <Input
        id="updates"
        name="updates"
        label={requestUpdates.updates}
        placeholder={requestUpdates.updatesPlaceholder}
        onChange={(value) => {
          if (value?.trim() || !value) {
            const modifiedValue = value.replace(/\s\s+/g, " ");
            if (value[0] !== " ") {
              setFieldTouched("updates");
              setFieldValue("updates", modifiedValue);
            }
          }
        }}
        value={values.updates}
        multiline
        rows={2}
        isInputHasErr={!!(touched.updates && errors.updates)}
        errMsg={errors.updates}
      />
    </form>
  );

  return (
    <div className="approve-documents">
      <Button
        label={
          <>
            <EditUnderlineIcon className="me-2" />
            {requestUpdates.btnLabel}
          </>
        }
        reversedcolor
        outlined
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && (
        <Modal
          open={modalOpen}
          icon={<EditBgIcon />}
          title={requestUpdates.confirmMsg.replace(
            ":companyName",
            requestDetails?.CompanyName || ""
          )}
          content={renderUpdatesInput()}
          isContentText={false}
          confirmBtnTxt={shared.send}
          cancelBtnTxt={shared.cancel}
          handleClose={() => {
            resetForm();
            setModalOpen(false);
          }}
          handleCancel={() => {
            resetForm();
            setModalOpen(false);
          }}
          handleConfirm={handleSubmit}
          disableConfirmBtn={!dirty || !isValid}
        />
      )}
    </div>
  );
};

export default RequestUpdates;
